export const phaseTypes = {
  ANY: 0,
  PICKUP: 1,
  NONSTANDART: 2,
  COMBINATION: 3,
};
